import styled, { css, keyframes } from "styled-components";

import { BoxSizingStyle } from "../../BoxSizingStyle";

const rotateAnimation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(359deg); }
`;

export interface StyledSpinnerLoaderProps {
  $diameter: number;
  $stroke: number;
  $activeStrokeColor: string;
  $inactiveStrokeColor: string;
  $activeColorPercentage: "25%" | "50%" | "75%";
  $rotateDurationInSeconds: number;
}

export const StyledSpinnerLoader = styled.div<StyledSpinnerLoaderProps>`
  ${BoxSizingStyle}
  border-radius: 100%;
  flex-shrink: 0;
  ${(props) =>
    css`
      width: ${props.$diameter}px;
      height: ${props.$diameter}px;
      animation: ${rotateAnimation} ${props.$rotateDurationInSeconds}s infinite
        linear;
    `}

  ${(props) =>
    props.$activeColorPercentage === "25%" &&
    css`
      border-right: ${props.$stroke}px solid ${props.$inactiveStrokeColor};
      border-bottom: ${props.$stroke}px solid ${props.$inactiveStrokeColor};
      border-left: ${props.$stroke}px solid ${props.$inactiveStrokeColor};
      border-top: ${props.$stroke}px solid ${props.$activeStrokeColor};
    `}

  ${(props) =>
    props.$activeColorPercentage === "50%" &&
    css`
      border-right: ${props.$stroke}px solid ${props.$activeStrokeColor};
      border-bottom: ${props.$stroke}px solid ${props.$inactiveStrokeColor};
      border-left: ${props.$stroke}px solid ${props.$inactiveStrokeColor};
      border-top: ${props.$stroke}px solid ${props.$activeStrokeColor};
    `}

    ${(props) =>
    props.$activeColorPercentage === "75%" &&
    css`
      border-right: ${props.$stroke}px solid ${props.$activeStrokeColor};
      border-bottom: ${props.$stroke}px solid ${props.$activeStrokeColor};
      border-left: ${props.$stroke}px solid ${props.$inactiveStrokeColor};
      border-top: ${props.$stroke}px solid ${props.$activeStrokeColor};
    `}
`;
